<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" title="修改" fontSize="14px" :useAutoOptional="false"
				:optional="hpidarr.length !== 1" @btnclick="update" :src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<CommonbtnUpLoad v-if="qx.add" style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF"
				title="医院导入" fontSize="14px" @getFile="hospitImport" types="file"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Export"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.union" title="并户" fontSize="14px"
				@btnclick="dialogCollect = true" :src="require('@/assets/icon/icon-fpcpx.png')">
			</Commonbtn>
			<!--省份角色设置 v-if="qx.setting"-->
			<Commonbtn backgroundColor="#FFF" title="省份角色设置" fontSize="14px" :useAutoOptional="false"
				:optional="hpidarr.length !== 1" @btnclick="openProvinceRoleDialog"
				:src="require('@/assets/icon/icon-fpcpx.png')">
			</Commonbtn>
			<a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
				@click="hospitDowload">下载医院导入模版</a>
			<a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
				@click="ProductlineDowload">下载省市区列表信息</a>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable ref="hospitalarchRef" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum=522 :tableData="tableData" :headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<!--合并客户-->
		<DialogFrom width="800px" title="合并客户" :dialogVisible="dialogCollect" @cancel="dialogClose"
			@dialogOK="handCollect">
			<div class="from">
				<template v-for="(item, index) of fromdatacollect">
					<Commondropdownlist :key="index" :event="item.event" ref="collhos" :radio="item.radio"
						:options="item.options" :btx="item.btx" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata"
						:disabled="item.disabled" @remoteMethodtows="remoteMethodtows">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>

		<DialogFrom width="1030px" title="新增档案" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
			<div class="from">
				<template v-for="(item, index) of fromdataadd">
					<Commondropdownlist :key="index" :event="item.event" @CusTypeChage="CusTypeChage" ref="addhos"
						:radio="item.radio" :options="item.options" :btx="item.btx" :inputdata="item.inputdata"
						:title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata"
						:disabled="item.disabled" @province="province" @city="city">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<DialogFrom width="1030px" title="修改医院档案" :dialogVisible="dialogVisiblesedit" @cancel="canceledit"
			@dialogOK="dialogOKedit">
			<div class="from">
				<template v-for="(item, index) of fromdataedit">
					<Commondropdownlist :key="index" :event="item.event" @CusTypeChage="CusTypeChage" ref="updatehos"
						:options="item.options" :btx="item.btx" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1"
						:radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min"
						:max="item.max" :checkboxdata="item.checkboxdata" :disabled="item.disabled" @province="province"
						@city="city">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条医院档案吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate"
			@dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用这条档案吗？</span>
		</Dialog>
		<DialogFrom width="1100px" title="省份角色设置" :dialogVisible="dialogProvinceRole" @cancel="closeProvinceRoleDialog"
			@dialogOK="saveProvinceRole" :CancelFlag="false" :dialogOKFlag="false">
			<div class="province-role-container">
				<div class="province-role-search">
					<div class="search-item">
						<label style="font-size: 14px; color: #333333; width: 70px; text-align: right;">产品线:</label>
						<el-select v-model="provinceRoleFormData.InvClass" clearable
							style="margin-left: 10px; width: 180px;" placeholder="请选择产品线" class="elselect">
							<el-option v-for="item in provinceRoleFormData.InvClassOptions" :key="item.key"
								:label="item.key" :value="item.value"></el-option>
						</el-select>
					</div>
					<div class="search-item">
						<label style="font-size: 14px; color: #333333; width: 70px; text-align: right;">省份:</label>
						<el-select v-model="provinceRoleFormData.ProvinceID" clearable
							style="margin-left: 10px; width: 180px;" placeholder="请选择省份" class="elselect">
							<el-option v-for="item in provinceRoleFormData.ProvinceOptions" :key="item.key"
								:label="item.key" :value="item.value"></el-option>
						</el-select>
					</div>
					<div class="search-item">
						<label style="font-size: 14px; color: #333333; width: 70px; text-align: right;">客户分类:</label>
						<el-select v-model="provinceRoleFormData.CusType" clearable
							style="margin-left: 10px; width: 180px;" placeholder="请选择客户分类" class="elselect">
							<el-option v-for="item in provinceRoleFormData.CusTypeOptions" :key="item.key"
								:label="item.key" :value="item.value"></el-option>
						</el-select>
					</div>
					<div class="search-buttons">
						<button class="btnreset" @click="resetProvinceRoleSearch">重置</button>
						<button class="btnselect" style="background-color: #e71d43;"
							@click="addProvinceRole">新增</button>
					</div>
				</div>
				<div class="province-role-action">
					<Commonbtn backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="deleteProvinceRole"
						:src="require('@/assets/icon/icon-del.png')">
					</Commonbtn>
					<CommonbtnUpLoad style="display: inline-block;" backgroundColor="#FFF" title="导入" fontSize="14px"
						@getFile="importProvinceRole" types="file" :src="require('@/assets/icon/icon-drjys.png')">
					</CommonbtnUpLoad>
					<a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
						@click="downloadProvinceRoleTemplet">下载导入模板</a>
				</div>
				<div class="province-role-table">
					<Commontable ref="provinceRoleTableRef" @handleSelectionChange="handleProvinceRoleSelectionChange"
						colnum=522 :tableData="provinceRoleTableData" :headerData="provinceRoleHeaderData" height="100%">
					</Commontable>
				</div>
			</div>
		</DialogFrom>
	</div>
</template>
<script>
import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
import Commontable from '../../../../components/common-table.vue'
import Commonbtn from '../../../../components/common-btn.vue'
import Pagination from '../../../../components/pagination.vue'
import DialogFrom from '../../../../components/dialog-from.vue'
import fromdata from '../fromData/add'
import fromdataedit from '../fromData/edit'
import Dialog from '../../../../components/dialog.vue'
import Commondown from '../../../../components/common-down.vue'
import arrAll from '../../../../common/area'
import CommonbtnUpLoad from '../../../../components/common-upload.vue'
import {
	HospitalInfo,
	HospitalAdd,
	HospitalEdit,
	HospitalDelete,
	GetHospitalType,
	GetProvince,
	GetCity,
	GetDistrict,
	HospitalImport,
	HospitalDownloadTemplet,
	CustomeDownloadAreaListr,
	HelperHosGrade,
	HospitalList,
	UnionHospital,
	GetHospitalTypeList,
	EditHospitalType,
	DelHospitalType,
	DownloadHospitalTypeTemplet,
	ImportHospitalType,
	InventoryClassList
} from '@/api/home'
export default {
	components: {
		Commontable,
		Commonbtn,
		Pagination,
		DialogFrom,
		Commondropdownlist,
		Dialog,
		Commondown,
		CommonbtnUpLoad
	},
	props: {
		tableData: {
			type: Array,
			default: []
		},
		total: {
			type: Number,
			default: 0
		}
	},
	data: function () {
		return {
			fromdatacollect: [{
				inputdata: "",
				title: "将客户",
				fontSize: "14px",
				color: "#333333",
				placeholder: "全部",
				types: "",
				inputtype: "selectautocompletes",
				width: "240px",
				btx: true,
				lablewith: "120px",
				options: []
			}, {
				inputdata: "",
				title: "并至客户",
				fontSize: "14px",
				color: "#333333",
				placeholder: "全部",
				types: "",
				inputtype: "selectautocompletes",
				width: "240px",
				btx: true,
				lablewith: "90px",
				options: []
			}],
			dialogCollect: false,
			dialogVisibles: false,
			dialogVisiblesedit: false,
			dialogVisibledel: false,
			dialogVisibledeactivate: false,
			dialogVisiblesU8: false,
			dialogVisiblesU8d: false,
			dialogVisiblesdrjg: false,
			dialogProvinceRole: false,
			rightboo: false,
			dwonleft: false,
			AddOrEdit: '',
			arrCityAll: arrAll, //全部城市
			cityArr: [], //市
			ptype: '',
			hpid: null,
			fromdataadd: [],
			fromdataedit: [],
			tableDatadrjg: [],
			hpidarr: [],
			title: '',
			from: {
				hpid: 0,
				prefix: "",
				hpCode: "",
				hpName: "",
				authorizeStatus: 0,
				provinceID: 0,
				cityID: 0,
				districtID: 0,
				address: "",
				hosType: "",
				technicalOffices: "",
				doctor: "",
				surgeryType: "",
				salesMan: "",
				pSalesMan: "",
				ppSalesMan: "",
				hosGrade: null,
				UsedName: "",
				SurgeryCountPerYear: ""
			},
			fromdataU8: [{
				inputdata: '',
				title: 'U8账套',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: 'text',
				inputtype: 'input',
				width: '210px',
				lablewith: '55px'
			}, {
				inputdata: '',
				title: 'U8编号',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: 'text',
				inputtype: 'input',
				width: '210px',
			},],
			headerData: [{
				prop: 'id',
				label: '序号',
				columnwidth: 50,
			},
			{

				prop: 'HPCode',
				label: '客户编号',
				columnwidth: 120
			},
			{
				prop: 'HPName',
				label: '客户名称',
				columnwidth: 220
			},
			{
				prop: 'UsedName',
				label: '曾用名',
				columnwidth: 150
			},
			{
				prop: 'SurgeryCountPerYear',
				label: '手术量/年',
				columnwidth: 150
			},
			{
				prop: 'AuthorizeStatusName',
				label: '授权状态',
				columnwidth: 80
			},
			{
				prop: 'Province',
				label: '省份',
				columnwidth: 80
			},
			{
				prop: 'City',
				label: '市',
				columnwidth: 80
			},
			{
				prop: 'District',
				label: '区',
				columnwidth: 80
			},
			{
				prop: 'Address',
				label: '地址',
				columnwidth: 280
			},
			{
				prop: 'HosType',
				label: '客户分类',
				columnwidth: 80
			},
			{
				prop: 'TechnicalOffices',
				label: '科室',
				columnwidth: 100
			},
			{
				prop: 'Doctor',
				label: '医生',
				columnwidth: 100
			},
			{
				prop: 'SurgeryType',
				label: '手术类型',
				columnwidth: 100
			},
			{
				prop: 'SalesMan',
				label: '销售人员',
				columnwidth: 100
			},
			{
				prop: 'PSalesMan',
				label: '销售人员上级',
				columnwidth: 100
			},
			{
				prop: 'PPSalesMan',
				label: '销售人员上上级',
				columnwidth: 100
			},
			{
				prop: 'CreatorName',
				label: '创建人',
				columnwidth: 130
			},
			{
				prop: 'CreateTime',
				label: '创建时间',
				columnwidth: 130
			},
			{
				prop: 'Updater',
				label: '修改人',
				columnwidth: 130
			},
			{
				prop: 'UpdateTime',
				label: '修改时间',
				columnwidth: 130
			}
			],
			tableData1: [],
			headerData1: [{
				prop: 'kong',
				columnwidth: 39,
				types: 'selection'

			},
			{
				prop: 'U8id',
				label: 'U8账套',
				columnwidth: 400,

			},
			{

				prop: 'U8number',
				label: 'U8编号',
				columnwidth: 522
			},
			],
			downlist: [{
				title: 'U8配置'
			},
			{
				title: '导入U8配置'
			},
			],
			qus: [],
			qx: {
				add: false,
				update: false,
				del: false,
				stopif: true,
				daoc: true,
				assignment: false,
				enabled: false,
				submit: false,
				skip: false,
				reset: false,
				setting: false,
				union: false
			},
			provinceRoleFormData: {
				InvClass: '',
				ProvinceID: '',
				CusType: '',
				InvClassOptions: [],
				ProvinceOptions: [],
				CusTypeOptions: []
			},
			provinceRoleTableData: [],
			provinceRoleTotal: 0,
			provinceRoleSelected: [],
			provinceRoleHeaderData: [
				{
					prop: 'id',
					label: '序号',
					columnwidth: 50
				},
				{
					prop: 'InvClassName',
					label: '产品线',
				},
				{
					prop: 'ProvinceName',
					label: '省份',
				},
				{
					prop: 'HosType',
					label: '客户分类',
				},
				{
					prop: 'Creator',
					label: '创建人',
				},
				{
					prop: 'CreateTime',
					label: '创建时间',
				}
			],
		}
	},
	created() {

	},
	mounted() {
		this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
		this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
		this.QX()
	},
	methods: {
		async remoteMethodtows(query) {
			let {
				code,
				data
			} = await HospitalList({
				hpName: query
			})
			if (code == 0) {
				this.fromdatacollect[0].options = []
				this.fromdatacollect[1].options = []
				data.data.map((item, index) => {
					let obj = {
						key: item.HPID,
						value: item.HPName
					}
					this.fromdatacollect[0].options.push(obj)
					this.fromdatacollect[1].options.push(obj)
				})
			}
		},
		dialogClose() {
			this.dialogCollect = false;
			this.fromdatacollect[0].options = [];
			this.fromdatacollect[1].options = [];
			this.$refs.collhos[0].modelvalue = '';
			this.$refs.collhos[1].modelvalue = '';
		},
		//并户
		async handCollect(IgnoreErr = false) {
			if (!this.$refs.collhos[0].modelvalue) {
				this.$message({
					type: 'error',
					message: '原客户未选择'
				});
				return;
			}
			if (!this.$refs.collhos[1].modelvalue) {
				this.$message({
					type: 'error',
					message: '新客户未选择'
				});
				return;
			}
			const loading = this.$loading({
				lock: true,
				text: '加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});

			let params = {
				oldHPID: this.$refs.collhos[0].modelvalue,
				newHPID: this.$refs.collhos[1].modelvalue
			}

			if (IgnoreErr) {
				params.IgnoreErr = true;
			}

			let {
				code,
				message,
				data
			} = await UnionHospital(params);
			loading.close();
			if (code == 0) {
				this.dialogClose();
				this.$message({
					type: 'success',
					message: res.message
				})
				this.$parent.hospitalList()
			} else if (code === 1) {
				this.$confirm(`<strong>${message}</strong><br/>${data.join(',<br/>')}`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					dangerouslyUseHTMLString: true
				}).then(() => { }).catch(() => { });
			} else if (code === 2) {
				this.$confirm(`<strong>${message}</strong><br/>${data.join(',<br/>')}`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					dangerouslyUseHTMLString: true
				}).then(() => {
					this.handCollect(true);
				}).catch(() => { });
			} else {
				this.$message({
					type: 'error',
					message: message
				});
			}
		},
		QX() {
			let data = JSON.parse(localStorage.getItem("MenusData"))
			data.Menus[0].Nodes.map((item, index) => {
				if (item.NodeID == 35) {
					item.Nodes.map((items, indexs) => {
						if (items.NodeID == 42) {
							this.qus = items.Nodes
						}
					})
				}
				console.log(this.qus, 'this.qus');
			})
			if (this.qus) {
				this.qus.map((item, index) => {
					if (item.NodeName == 'add') {
						this.qx.add = true
					} else if (item.NodeName == 'edit') {
						this.qx.update = true
					} else if (item.NodeName == 'delete') {
						this.qx.del = true
					} else if (item.NodeName == 'stopif') {
						this.qx.del = true
					} else if (item.NodeName == 'assignment') {
						this.qx.assignment = true
					} else if (item.NodeName == 'enabled') {
						this.qx.enabled = true
					} else if (item.NodeName == 'skip') {
						this.qx.skip = true
					} else if (item.NodeName == 'reset') {
						this.qx.reset = true
					} else if (item.NodeName == 'setting') {
						this.qx.setting = true
					} else if (item.NodeName == 'union') {
						this.qx.union = true
					}
				})
			}

		},
		// 导入
		async hospitalImport(file) {
			if (file) {
				const loading = this.$loading({
					lock: true,
					text: '上传中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formData = new FormData()
				formData.append("file", file)
				let res = await HospitalImport(formData)
				if (res.code == 0) {
					this.$message({
						type: 'success',
						message: res.message
					})
					loading.close();
				} else if (res.code == 101) {
					this.$message({
						type: 'warning',
						message: res.message
					})
					loading.close();
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = res.data
					this.title = "导入结果"
					this.$message({
						type: 'error',
						message: res.message
					})
					loading.close();
				}
				this.$parent.hospitalList()
				loading.close();
			}
		},
		hospitImport(file) {
			this.hospitalImport(file)
		},
		async hospitalDownloadTemplet() {
			// 测试
			// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
			let {
				data,
				code,
				message
			} = await HospitalDownloadTemplet({})
			if (code == 0) {
				window.location.href = data
			} else if (code == 101) {
				this.$message({
					type: 'warning',
					message: message
				});
			} else {
				this.$message({
					type: 'error',
					message: message
				});
			}
		},
		hospitDowload() {
			this.hospitalDownloadTemplet()
		},
		// 新增
		async hospitalAdd() {
			let {
				code,
				message
			} = await HospitalAdd({
				prefix: this.from.prefix,
				hpCode: this.from.hpCode,
				hpName: this.from.hpName,
				authorizeStatus: Number(this.from.authorizeStatus),
				provinceID: Number(this.from.provinceID),
				cityID: Number(this.from.cityID),
				districtID: Number(this.from.districtID),
				address: this.from.address,
				hosType: this.from.hosType,
				technicalOffices: this.from.technicalOffices,
				doctor: this.from.doctor,
				surgeryType: this.from.surgeryType,
				salesMan: this.from.salesMan,
				pSalesMan: this.from.pSalesMan,
				ppSalesMan: this.from.ppSalesMan,
				hosGrade: this.from.hosGrade,
				UsedName: this.from.UsedName,
				SurgeryCountPerYear: this.from.SurgeryCountPerYear
			})
			if (code == 0) {
				this.$message({
					type: 'success',
					message: '新增成功'
				});
				this.rowboo = false
				this.dialogVisibles = false
				this.$parent.hospitalList()
			} else {
				this.$message({
					type: 'error',
					message: message
				});
			}
			this.$refs.addhos.map((item, index) => {
				if (index != 7) {
					item.radio = "0"

				}
				item.modelvalue = ""
			})
			this.hpiIDArr = []
		},
		// 详情
		async hospitalInfo() {
			// const loading = this.$loading({
			//   lock: true,
			//   text: '加载中...',
			//   spinner: 'el-icon-loading',
			//   background: 'rgba(255,255,255,0.3)'
			// });
			let {
				code,
				data,
				message
			} = await HospitalInfo({
				hpid: this.hpid
			})
			if (code == 0) {
				this.getProvince()

				this.$refs.updatehos[0].modelvalue = data.HPCode
				this.$refs.updatehos[1].modelvalue = data.HPName
				this.$refs.updatehos[2].modelvalue = data.Prefix
				this.$refs.updatehos[3].modelvalue = data.ProvinceID == 0 ? "" : String(data.ProvinceID)
				this.$refs.updatehos[4].modelvalue = data.CityID == 0 ? "" : String(data.CityID)
				this.$refs.updatehos[5].modelvalue = data.DistrictID == 0 ? "" : String(data.DistrictID)

				this.$refs.updatehos[6].modelvalue = data.Address
				this.$refs.updatehos[7].radios = data.AuthorizeStatus + ""

				this.$refs.updatehos[8].modelvalue = data.HosType
				this.$refs.updatehos[9].modelvalue = data.TechnicalOffices
				this.$refs.updatehos[10].modelvalue = data.Doctor
				this.$refs.updatehos[11].modelvalue = data.SurgeryType

				this.$refs.updatehos[12].modelvalue = data.SalesMan
				this.$refs.updatehos[13].modelvalue = data.PSalesMan
				this.$refs.updatehos[14].modelvalue = data.PPSalesMan
				this.$refs.updatehos[15].modelvalue = data.HosGrade
				this.$refs.updatehos[16].modelvalue = data.UsedName
				this.$refs.updatehos[17].modelvalue = data.SurgeryCountPerYear
				if (data.HosType == '医院') {
					this.HelperHosGrade()
				}
				this.getcity(data.ProvinceID)
				this.getDistrict(data.CityID)
			} else {
				this.$message.error(message)
			}
			// loading.close();
		},
		// 修改
		async hospitalEdit(datalist) {
			let {
				code,
				message
			} = await HospitalEdit({
				hpid: this.hpid,
				prefix: datalist[2].modelvalue,
				hpCode: datalist[0].modelvalue,
				hpName: datalist[1].modelvalue,
				authorizeStatus: Number(datalist[7].radios),
				provinceID: Number(datalist[3].modelvalue),
				cityID: Number(datalist[4].modelvalue),
				districtID: Number(datalist[5].modelvalue),
				address: datalist[6].modelvalue,
				hosType: datalist[8].modelvalue,
				technicalOffices: datalist[9].modelvalue,
				doctor: datalist[10].modelvalue,
				surgeryType: datalist[11].modelvalue,
				salesMan: datalist[12].modelvalue,
				pSalesMan: datalist[13].modelvalue,
				ppSalesMan: datalist[14].modelvalue,
				hosGrade: datalist[15].modelvalue,
				UsedName: datalist[16].modelvalue,
				SurgeryCountPerYear: datalist[17].modelvalue,
			})
			if (code == 0) {
				this.$message({
					type: 'success',
					message: '修改成功'
				});
				this.rowboo = false
				this.dialogVisiblesedit = false
				this.$parent.hospitalList()
				this.hpidarr.length = 0
				this.setCurrent()
			} else {
				this.$message({
					type: 'error',
					message: message
				});
			}
		},
		// 删除
		async hospitalDelete() {
			let hpiIDArr = []
			this.hpidarr.map((item, index) => {
				hpiIDArr.push(item.HPID)
			})
			let {
				code,
				message,
				data
			} = await HospitalDelete({
				hpiDs: hpiIDArr
			})
			if (code == 0) {
				this.$message({
					type: 'success',
					message: '删除成功'
				});
				this.$parent.hospitalList()
				this.hpidarr.length = 0
				hpiIDArr.length = 0
				//console.log(this.hpidarr, hpiIDArr);
			} else {
				this.dialogVisiblesdrjg = true
				this.tableDatadrjg = data
				this.title = "删除结果"
				this.$message({
					type: 'error',
					message: message
				});
			}

		},
		//医院分类
		async GetHospitalType() {
			let {
				code,
				data
			} = await GetHospitalType({

			})
			if (code == 0) {
				this.fromdataadd[8].options = []
				this.fromdataedit[8].options = []
				data.map((item, index) => {
					let obj = {
						value: item.Name
					}
					this.fromdataadd[8].options.push(obj)
					this.fromdataedit[8].options.push(obj)
				})
			}
		},

		// 省
		async getProvince() {
			let {
				code,
				data
			} = await GetProvince({

			})
			if (code == 0) {
				this.fromdataadd[3].options = []
				this.fromdataedit[3].options = []
				data.map((item, index) => {
					let obj = {
						key: item.Value,
						value: item.Text
					}
					this.fromdataadd[3].options.push(obj)
					this.fromdataedit[3].options.push(obj)
				})
			}
		},
		// 市
		async getcity(provinceid) {
			let params = {
				ProvinceID: provinceid
			}
			let {
				code,
				data
			} = await GetCity({
				params
			})
			if (code == 0) {
				this.fromdataadd[4].options = []
				this.fromdataedit[4].options = []
				data.map((item, index) => {
					let obj = {
						key: item.Value,
						value: item.Text
					}
					this.fromdataadd[4].options.push(obj)
					this.fromdataedit[4].options.push(obj)
				})
			}
		},
		// 区
		async getDistrict(cityID) {
			let params = {
				CityID: cityID
			}
			let {
				code,
				data
			} = await GetDistrict({
				params
			})
			if (code == 0) {
				this.fromdataadd[5].options = []
				this.fromdataedit[5].options = []
				data.map((item, index) => {
					let obj = {
						key: item.Value,
						value: item.Text
					}
					this.fromdataadd[5].options.push(obj)
					this.fromdataedit[5].options.push(obj)
				})
			}
		},
		async customeDownloadAreaListr() {
			// 测试
			// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
			let {
				data,
				code,
				message
			} = await CustomeDownloadAreaListr({})
			if (code == 0) {
				window.location.href = data
			} else if (code == 101) {
				this.$message({
					type: 'warning',
					message: message
				});
			} else {
				this.$message({
					type: 'error',
					message: message
				});
			}
		},
		ProductlineDowload() {
			this.customeDownloadAreaListr()
		},
		onRowClick(val) {
			this.rowboo = true
			this.hpid = val.HPID
		},
		handleSelectionChange(val) {
			this.hpidarr = val
			if (val.length === 1) {
				this.hpid = val[0].HPID
				this.rowboo = true
				return
			}
			this.rowboo = false
			if (val.length === 0) {
				this.hpid = null
			}
		},
		handleCurrentChange(pageindex) {
			this.$emit('handleCurrentChange', pageindex)
		},
		handleSizeChange(paegSzie) {
			this.$emit('handleSizeChange', paegSzie)
		},
		// 医院等级
		async HelperHosGrade() {
			let {
				code,
				data,
				message
			} = await HelperHosGrade({})
			if (code == 0) {
				if (this.AddOrEdit == 'Add') {
					this.fromdataadd[15].options = []
					data.forEach((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.fromdataadd[15].options.push(obj)
					});
				} else if (this.AddOrEdit == 'Edit') {
					this.fromdataedit[15].options = []
					data.forEach((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.fromdataedit[15].options.push(obj)
					});
				}
			} else {
				this.$message.error(message)
			}
		},
		// 获取客户分类onChage
		CusTypeChage(e) {
			console.log(e.modelvalue, 'e');
			if (e.modelvalue == '医院') {
				this.HelperHosGrade()
				return
			}
			if (this.AddOrEdit == 'Add') {
				this.fromdataadd[15].options = []
				this.$refs.addhos[15].modelvalue = ''
			} else if (this.AddOrEdit == 'Edit') {
				this.fromdataedit[15].options = []
				this.$refs.updatehos[15].modelvalue = ''
			}
		},
		Export() {
			this.$emit('Export')
		},
		adduser() {
			this.GetHospitalType()
			this.getProvince()
			this.dialogVisibles = true
			this.AddOrEdit = 'Add'
		},
		cancel() {
			this.dialogVisibles = false
		},
		province(val) {
			this.getcity(val)
		},
		city(val) {
			this.getDistrict(val)
			//console.log("jajja", val);
		},
		dialogOK() {
			// //console.log(this.$refs.addhos[3].modelvalue, "kkk")
			this.from.prefix = this.$refs.addhos[2].modelvalue,
				this.from.hpCode = this.$refs.addhos[0].modelvalue,
				this.from.hpName = this.$refs.addhos[1].modelvalue,
				this.from.authorizeStatus = this.$refs.addhos[7].radios,
				this.from.provinceID = this.$refs.addhos[3].modelvalue,
				this.from.cityID = this.$refs.addhos[4].modelvalue,
				this.from.districtID = this.$refs.addhos[5].modelvalue,
				this.from.address = this.$refs.addhos[6].modelvalue,
				this.from.hosType = this.$refs.addhos[8].modelvalue,
				this.from.technicalOffices = this.$refs.addhos[9].modelvalue,
				this.from.doctor = this.$refs.addhos[10].modelvalue,
				this.from.surgeryType = this.$refs.addhos[11].modelvalue,
				this.from.salesMan = this.$refs.addhos[12].modelvalue,
				this.from.pSalesMan = this.$refs.addhos[13].modelvalue,
				this.from.ppSalesMan = this.$refs.addhos[14].modelvalue,
				this.from.hosGrade = this.$refs.addhos[15].modelvalue,
				this.from.UsedName = this.$refs.addhos[16].modelvalue,
				this.from.SurgeryCountPerYear = this.$refs.addhos[17].modelvalue,
				this.hospitalAdd()
		},
		update() {
			if (this.hpidarr.length === 1) {
				this.hpid = this.hpidarr[0].HPID
				this.rowboo = true
				this.dialogVisiblesedit = true
				this.AddOrEdit = 'Edit'
				this.GetHospitalType()
				this.hospitalInfo()
				return
			}
			this.$message({
				type: 'error',
				message: '请选择要修改的数据！'
			});

		},
		canceledit() {
			this.dialogVisiblesedit = false
		},
		dialogOKedit() {
			this.hospitalEdit(this.$refs.updatehos)

		},
		del() {
			if (this.hpidarr.length > 0) {
				this.dialogVisibledel = true
				return
			}
			this.$message({
				type: 'error',
				message: '请选择要删除的数据！'
			});

		},
		canceldel() {
			this.dialogVisibledel = false
		},
		dialogOKdel() {
			this.hospitalDelete()
			this.dialogVisibledel = false
		},
		deactivate() {
			this.dialogVisibledeactivate = true
		},
		canceldeactivate() {
			this.dialogVisibledeactivate = false
		},
		dialogOKdeactivate() {
			this.dialogVisibledeactivate = false
		},
		downs(index) {
			// //console.log("index", index)
			if (index == 0) {
				this.dialogVisiblesU8 = true
			}
			if (index == 1) {
				this.dialogVisiblesU8d = true
			}
		},
		cancelU8() {
			this.dialogVisiblesU8 = false
		},
		dialogOKeditU8() {
			this.dialogVisiblesU8 = false
		},
		cancelU8d() {
			this.dialogVisiblesU8d = false
		},
		dialogOKeditU8d() {
			this.dialogVisiblesU8d = false
		},
		canceldrjg() {
			this.dialogVisiblesdrjg = false
		},
		dialogOKdrjg() {
			this.dialogVisiblesdrjg = false
		},
		// 取消选中状态
		setCurrent(row) {
			this.$refs.hospitalarchRef.$refs.fileTableSelect.setCurrentRow(row);
		},
		async openProvinceRoleDialog() {
			if (this.hpidarr.length !== 1) {
				this.$message({
					type: 'warning',
					message: '请选择一条数据'
				});
				return;
			}
			this.dialogProvinceRole = true;
			this.provinceRoleFormData.InvClass = '';
			this.provinceRoleFormData.ProvinceID = '';
			this.provinceRoleFormData.CusType = '';
			await this.loadProvinceRoleOptions();
			this.loadProvinceRoleList();
		},
		async loadProvinceRoleOptions() {
			const loading = this.$loading({
				lock: true,
				text: '加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			try {
				const [invClassRes, provinceRes, cusTypeRes] = await Promise.all([
					InventoryClassList({}),
					GetProvince({}),
					GetHospitalType({})
				]);
				this.provinceRoleFormData.InvClassOptions = (invClassRes.data.data || invClassRes || []).map(item => ({
					key: item.InvClassName,
					value: item.InvClass
				}));
				this.provinceRoleFormData.ProvinceOptions = (provinceRes.data || provinceRes || []).map(item => ({
					key: item.Text,
					value: item.Value
				}));
				this.provinceRoleFormData.CusTypeOptions = (cusTypeRes.data || cusTypeRes || []).map(item => ({
					key: item.Name,
					value: item.Name
				}));
			} catch (error) {
				console.error('加载选项失败', error);
				this.$message.error('加载选项失败');
			}
			loading.close();
		},
		async loadProvinceRoleList() {
			const loading = this.$loading({
				lock: true,
				text: '加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			try {
				const res = await GetHospitalTypeList({
					params: {
						HPID: this.hpid
					}
				});
				if (res.code == 0) {
					this.provinceRoleTableData = res.data.map((item, index) => ({
						...item,
						id: index + 1,
						CreateTime: item.CreateTime ? item.CreateTime.split('T')[0] : ''
					}));
					this.provinceRoleTotal = res.data.length;
				} else {
					this.$message.error(res.message);
				}
			} catch (error) {
				this.$message.error('加载数据失败');
			}
			loading.close();
		},
		async searchProvinceRoleList() {
			await this.loadProvinceRoleList();
		},
		resetProvinceRoleSearch() {
			this.provinceRoleFormData.InvClass = '';
			this.provinceRoleFormData.ProvinceID = '';
			this.provinceRoleFormData.CusType = '';
		},
		closeProvinceRoleDialog() {
			this.dialogProvinceRole = false;
		},
		saveProvinceRole() {
			this.dialogProvinceRole = false;
		},
		handleProvinceRoleSelectionChange(val) {
			this.provinceRoleSelected = val;
		},
		async addProvinceRole() {
			if (!this.provinceRoleFormData.InvClass) {
				this.$message({
					type: 'warning',
					message: '请选择产品线'
				});
				return;
			}
			if (!this.provinceRoleFormData.ProvinceID) {
				this.$message({
					type: 'warning',
					message: '请选择省份'
				});
				return;
			}
			if (!this.provinceRoleFormData.CusType) {
				this.$message({
					type: 'warning',
					message: '请选择客户分类'
				});
				return;
			}
			const loading = this.$loading({
				lock: true,
				text: '保存中...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			try {
				const res = await EditHospitalType({
					HPID: this.hpid,
					InvClass: this.provinceRoleFormData.InvClass,
					ProvinceID: this.provinceRoleFormData.ProvinceID,
					HosType: this.provinceRoleFormData.CusType
				});
				if (res.code == 0) {
					this.$message({
						type: 'success',
						message: '新增成功'
					});
					this.loadProvinceRoleList();
				} else {
					this.$message.error(res.message);
				}
			} catch (error) {
				this.$message.error('新增失败');
			}
			loading.close();
		},
		async deleteProvinceRole() {
			if (this.provinceRoleSelected.length === 0) {
				this.$message({
					type: 'warning',
					message: '请选择要删除的数据'
				});
				return;
			}
			const loading = this.$loading({
				lock: true,
				text: '删除中...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			try {
				const ids = this.provinceRoleSelected.map(item => item.ID || item.Id);
				const res = await DelHospitalType({
					IDs: ids
				});
				if (res.code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.provinceRoleSelected = [];
					if (this.$refs.provinceRoleTableRef && this.$refs.provinceRoleTableRef.$refs.fileTableSelect) {
						this.$refs.provinceRoleTableRef.$refs.fileTableSelect.clearSelection();
					}
					this.loadProvinceRoleList();
				} else {
					this.$message.error(res.message);
				}
			} catch (error) {
				this.$message.error('删除失败');
			}
			loading.close();
		},
		async importProvinceRole(file) {
			if (!file) return;
			const loading = this.$loading({
				lock: true,
				text: '导入中...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			try {
				let formData = new FormData();
				formData.append('file', file);
				const res = await ImportHospitalType(formData);
				if (res.code == 0) {
					this.$message({
						type: 'success',
						message: res.message || '导入成功'
					});
					this.loadProvinceRoleList();
				} else if (res.code == 1 && res.data && res.data.length > 0) {
					this.$message({
						type: 'success',
						message: res.message || '导入成功'
					});
					this.provinceRoleTableData = res.data.map((item, index) => ({
						...item,
						id: index + 1,
						CreateTime: item.CreateTime ? item.CreateTime.split('T')[0] : ''
					}));
					this.provinceRoleTotal = res.data.length;
				} else {
					this.$message.error(res.message);
				}
			} catch (error) {
				this.$message.error('导入失败');
			}
			loading.close();
		},
		async downloadProvinceRoleTemplet() {
			const loading = this.$loading({
				lock: true,
				text: '下载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			try {
				const res = await DownloadHospitalTypeTemplet({});
				if (res.code == 0) {
					window.location.href = res.data;
				} else {
					this.$message.error(res.message);
				}
			} catch (error) {
				this.$message.error('下载模板失败');
			}
			loading.close();
		}
	},
	watch: {
		dialogVisiblesedit: {
			handler(newVal, oldValue) {
				if (newVal == false) {
					// this.$refs.hospitalarchRef.fileTableSelect.setCurrentRow(row)
				}
			}
		}
	}
}
</script>

<style lang="less" scoped>
.incenters {
	height: 100%;

	.pagination {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 16px;
		padding-bottom: 16px;
	}

	// div {
	//   margin-left: 8px;
	//   margin-right: 8px;
	//   margin-top: 5px;
	//   margin-bottom: 5px;

	// }
	.from {
		width: 100%;
	}

	.signingroles {
		height: 500px;
		width: 100%;
		// display: flex;
		// justify-content: space-between;
		// align-items: center;
		// border: 1px solid red;

		.left {
			height: 240px;
			width: 470px;
			border: 1px solid #e6e6e6;
		}

		.right {
			height: 240px;
			width: 470px;
			border: 1px solid #e6e6e6;
			// pointer-events: none;
		}
	}
}

.right-s {
	position: absolute;
	z-index: 99;
	opacity: 0.5;
	right: 21px;
	width: 470px;
	height: 240px;
	background-color: #ffffff;
	cursor: no-drop;
}

.dwonleft {
	width: 170px;
	height: 48px;
	position: absolute;
	background-color: #ffffff;
	z-index: 99;
	right: 350px;
	top: 322px;
	text-align: center;
	line-height: 48px;
	color: #333333;
	box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
		0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
	border-radius: 2px;
	font-size: 14px;
	cursor: pointer;
}

.dwonleft:hover {
	background-color: #f0f0f0;
}

.province-role-container {
	.province-role-search {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		margin-bottom: 15px;

		.search-item {
			display: flex;
			align-items: center;
			margin-right: 20px;

			.search-label {
				font-size: 14px;
				color: #333333;
				margin-right: 8px;
				white-space: nowrap;
			}
		}

		.search-buttons {
			display: flex;
			align-items: center;
			margin-left: 20px;

			.btnreset {
				width: 64px;
				height: 32px;
				border: 1px solid #e6e6e6;
				background-color: #fff;
				border-radius: 2px;
				text-align: center;
				cursor: pointer;
			}

			.btnreset:hover {
				background-color: #f9f9f9;
			}

			.btnselect {
				width: 64px;
				height: 32px;
				border: 1px solid #e6e6e6;
				border-radius: 2px;
				text-align: center;
				color: #fff;
				background-color: #e71d43;
				margin-left: 10px;
				cursor: pointer;
			}

			.btnselect:hover {
				background-color: #e03f5d;
			}
		}
	}

	.province-role-action {
		margin-bottom: 10px;
	}

	.province-role-table {
		height: 350px;
	}
}

.province-role-search {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		margin-bottom: 15px;
		.search-item {
			display: flex;
			align-items: center;
			margin-right: 20px;
			.search-label {
				font-size: 14px;
				color: #333333;
				margin-right: 8px;
				white-space: nowrap;
			}
		}
		.search-buttons {
			display: flex;
			align-items: center;
			margin-left: 20px;
			.btnreset {
				width: 64px;
				height: 32px;
				border: 1px solid #e6e6e6;
				background-color: #fff;
				border-radius: 2px;
				text-align: center;
				cursor: pointer;
				line-height: 32px;
				font-size: 14px;
			}
			.btnreset:hover {
				background-color: #f9f9f9;
			}
			.btnselect {
				width: 64px;
				height: 32px;
				border: 1px solid #e6e6e6;
				border-radius: 2px;
				text-align: center;
				color: #fff;
				background-color: #e71d43;
				margin-left: 10px;
				cursor: pointer;
				line-height: 32px;
				font-size: 14px;
			}
			.btnselect:hover {
				background-color: #e03f5d;
			}
		}
		.elselect {
			/deep/.el-input__icon {
				line-height: normal;
			}
			/deep/.el-input__suffix {
				right: 3px;
			}
			/deep/.el-input--suffix .el-input__inner {
				padding-right: 30px;
				height: 32px !important;
				width: 180px;
				border-radius: 2px;
				border: 1px solid #e6e8eb;
			}
		}
		/deep/.el-input__inner {
			border: 1px solid #e6e8eb;
			font-size: 14px;
			color: #16181a;
			border-radius: 2px;
			height: 32px;
			padding-left: 10px;
			padding-right: 30px;
		}
		/deep/.el-select .el-input.is-focus .el-input__inner {
			border-color: #e71d43;
		}
		/deep/.el-select .el-input__inner:focus {
			border-color: #e71d43;
		}
		/deep/.el-icon-circle-close {
			color: #999;
			font-size: 12px;
			margin-right: 5px;
		}
	}
</style>
